import { Box, Typography } from "@mui/material";
import { VersionDetailsProps } from "../types";
import { versionDetailsStyles } from "../styles";
import { styles } from "./styles";

export const VersionDetails: React.FC<VersionDetailsProps> = ({
  selectedTrackVersionLabel,
  versions,
}) => {
  return (
    <>
      <Box sx={styles.versionDetailsContainer}>
        <Typography noWrap sx={versionDetailsStyles.currentVersionLabel}>
          {selectedTrackVersionLabel
            ? selectedTrackVersionLabel
            : "no versions"}
        </Typography>

        <Typography sx={versionDetailsStyles.CurrentVersionCount}>
          Versions: {versions?.length}
        </Typography>
      </Box>
    </>
  );
};
